export default {
  en: {
    verificationPortalPage: {
      status: {
        pending: "pending",
        submitted: "submitted",
        correction_requested: "correction requested",
        correction_submitted: "correction submitted",
        approved: "approved",
        certified: "certified",
        rejected: "rejected"
      },
      actions: {
        approve: "approve",
        reject: "reject",
        request_correction: "request correction"
      },
      electionTypes: {
        council: "Council",
        senatorial: "Senatorial",
        presidential: "Presidential",
        parliamentary: "Parliamentary",
        regional: "Regional"
      },
      noPermission: "You don't have permission to access the verification portal",
      lockAcquired: "Edit lock acquired",
      lockAcquiredDesc: "You can now review this result safely.",
      resultLocked: "Result is locked",
      lockedBy: "Currently being edited by {{name}}",
      lockFailed: "Failed to acquire lock",
      lockReleased: "Edit lock released",
      selectActionAndComments: "Please select an action and provide comments",
      commentsMin: "Comments must be at least 5 characters",
      resultApproved: "Result approved",
      resultRejected: "Result rejected",
      resultCorrection: "Result sent for correction",
      reviewFailed: "Failed to submit review",
      certifyPrompt: "Enter certification comments:",
      certified: "Result certified successfully",
      certifyFailed: "Failed to certify result",
      detailsFailed: "Failed to load result details",
      title: "Results Verification Portal",
      subtitle: "Review, approve, or request corrections for election results",
      refresh: "Refresh",
      pendingReview: "Pending Review",
      correctionsPending: "Corrections Pending",
      approvedLabel: "Approved",
      certifiedLabel: "Certified",
      rejectedLabel: "Rejected",
      filters: "Filters:",
      electionType: "Election Type",
      allTypes: "All Types",
      region: "Region",
      allRegions: "All Regions",
      resultsFound: "{{count}} results found",
      pendingVerification: "Results Pending Verification",
      loadingResults: "Loading results...",
      allCaughtUp: "All caught up!",
      nothingPending: "No results pending verification",
      unknownLocation: "Unknown Location",
      notAvailable: "N/A",
      submittedOn: "Submitted {{date}}",
      correctionRequested: "Correction requested:",
      valid: "Valid:",
      rejected: "Rejected:",
      total: "Total:",
      view: "View",
      review: "Review",
      certify: "Certify",
      reviewResult: "Review Result",
      electionSuffix: "{{type}} Election",
      action: "Action *",
      approveBtn: "Approve",
      correctBtn: "Correct",
      rejectBtn: "Reject",
      commentsLabel: "Comments * (min 5 characters)",
      commentsPlaceholder: "Enter your review comments...",
      cancel: "Cancel",
      submitReview: "Submit Review",
      detailsTitle: "Result Details - Full Review",
      location: "Location",
      statusLabel: "Status",
      submittedLabel: "Submitted",
      submittedBy: "Submitted By",
      unknown: "Unknown",
      attempt: "Attempt #{{n}}",
      registeredVoters: "Registered Voters",
      totalVotesCast: "Total Votes Cast",
      validVotes: "Valid Votes",
      rejectedVotes: "Rejected Votes",
      candidateVotes: "Candidate Votes",
      partyVotes: "Party Votes",
      resultSheetPhoto: "Result Sheet Photo",
      resultSheetAlt: "Result Sheet",
      clickToEnlarge: "Click to enlarge",
      clickToClose: "Click anywhere to close",
      additionalPhotos: "Additional Photos ({{n}})",
      additionalPhotoAlt: "Additional photo {{n}}",
      submitterNotes: "Submitter Notes",
      reviewHistory: "Review History",
      close: "Close",
      reviewThisResult: "Review This Result"
    }
  },
  fr: {
    verificationPortalPage: {
      status: {
        pending: "en attente",
        submitted: "soumis",
        correction_requested: "correction demandée",
        correction_submitted: "correction soumise",
        approved: "approuvé",
        certified: "certifié",
        rejected: "rejeté"
      },
      actions: {
        approve: "approuver",
        reject: "rejeter",
        request_correction: "demander une correction"
      },
      electionTypes: {
        council: "Municipales",
        senatorial: "Sénatoriales",
        presidential: "Présidentielle",
        parliamentary: "Législatives",
        regional: "Régionales"
      },
      noPermission: "Vous n'avez pas l'autorisation d'accéder au portail de vérification",
      lockAcquired: "Verrou d'édition acquis",
      lockAcquiredDesc: "Vous pouvez désormais examiner ce résultat en toute sécurité.",
      resultLocked: "Le résultat est verrouillé",
      lockedBy: "Actuellement en cours de modification par {{name}}",
      lockFailed: "Échec de l'acquisition du verrou",
      lockReleased: "Verrou d'édition libéré",
      selectActionAndComments: "Veuillez sélectionner une action et fournir des commentaires",
      commentsMin: "Les commentaires doivent contenir au moins 5 caractères",
      resultApproved: "Résultat approuvé",
      resultRejected: "Résultat rejeté",
      resultCorrection: "Résultat renvoyé pour correction",
      reviewFailed: "Échec de l'envoi de l'examen",
      certifyPrompt: "Saisissez les commentaires de certification :",
      certified: "Résultat certifié avec succès",
      certifyFailed: "Échec de la certification du résultat",
      detailsFailed: "Échec du chargement des détails du résultat",
      title: "Portail de vérification des résultats",
      subtitle: "Examinez, approuvez ou demandez des corrections pour les résultats électoraux",
      refresh: "Actualiser",
      pendingReview: "En attente d'examen",
      correctionsPending: "Corrections en attente",
      approvedLabel: "Approuvés",
      certifiedLabel: "Certifiés",
      rejectedLabel: "Rejetés",
      filters: "Filtres :",
      electionType: "Type d'élection",
      allTypes: "Tous les types",
      region: "Région",
      allRegions: "Toutes les régions",
      resultsFound: "{{count}} résultats trouvés",
      pendingVerification: "Résultats en attente de vérification",
      loadingResults: "Chargement des résultats...",
      allCaughtUp: "Tout est à jour !",
      nothingPending: "Aucun résultat en attente de vérification",
      unknownLocation: "Lieu inconnu",
      notAvailable: "N/D",
      submittedOn: "Soumis le {{date}}",
      correctionRequested: "Correction demandée :",
      valid: "Valides :",
      rejected: "Rejetés :",
      total: "Total :",
      view: "Voir",
      review: "Examiner",
      certify: "Certifier",
      reviewResult: "Examiner le résultat",
      electionSuffix: "Élection {{type}}",
      action: "Action *",
      approveBtn: "Approuver",
      correctBtn: "Corriger",
      rejectBtn: "Rejeter",
      commentsLabel: "Commentaires * (5 caractères minimum)",
      commentsPlaceholder: "Saisissez vos commentaires d'examen...",
      cancel: "Annuler",
      submitReview: "Envoyer l'examen",
      detailsTitle: "Détails du résultat - Examen complet",
      location: "Lieu",
      statusLabel: "Statut",
      submittedLabel: "Soumis",
      submittedBy: "Soumis par",
      unknown: "Inconnu",
      attempt: "Tentative n° {{n}}",
      registeredVoters: "Électeurs inscrits",
      totalVotesCast: "Total des votes exprimés",
      validVotes: "Votes valides",
      rejectedVotes: "Votes rejetés",
      candidateVotes: "Votes des candidats",
      partyVotes: "Votes des partis",
      resultSheetPhoto: "Photo de la feuille de résultats",
      resultSheetAlt: "Feuille de résultats",
      clickToEnlarge: "Cliquez pour agrandir",
      clickToClose: "Cliquez n'importe où pour fermer",
      additionalPhotos: "Photos supplémentaires ({{n}})",
      additionalPhotoAlt: "Photo supplémentaire {{n}}",
      submitterNotes: "Notes du soumissionnaire",
      reviewHistory: "Historique des examens",
      close: "Fermer",
      reviewThisResult: "Examiner ce résultat"
    }
  }
};
